$(() => {
  function setDropdownText(dropdown, required, count) {
    const openDropdownButton  = dropdown.find('[data-bs-toggle="dropdown"]');
    const hiddenDefaultBorder = openDropdownButton.hasClass('hidden-border');
    const countSpan           = openDropdownButton.find('.selected-count-text');

    countSpan.text(`(${count})`);
    if (required) {
      const classes = 'border border-danger';
      if (count === 0) {
        openDropdownButton.addClass(classes);
        if (hiddenDefaultBorder) {
          openDropdownButton.removeClass('border-0');
        }
      } else {
        openDropdownButton.removeClass(classes);
        if (hiddenDefaultBorder) {
          openDropdownButton.addClass('border-0');
        }
      }
    }
  }

  function enableSubmit(form) {
    const requiredDropdowns = form.find('.required-dropdown');
    const submitButton      = form.find('.btn-submit');

    if (requiredDropdowns.length) {
      var allRequiredHaveSelected = true;
      requiredDropdowns.each((idx, el) => {
        const inputs = $(el).find('input.form-check-input').not('.select-all-checkbox');
        allRequiredHaveSelected &= (inputs.filter(':checked').length !== 0);
      });
      submitButton.prop('disabled', !allRequiredHaveSelected);
    }
  }

  // Search Functionality
  $('.searchable-dropdown').each((idx, el) => {
    const checks          = $(el).find('.form-check');
    const searchBox       = $(el).find('.searchable-dropdown-search');
    const labelToCheckbox = checks.map((idx, el) => {
      const label     = $(el).children('.searchable-dropdown-label');
      const labelText = label.text().toLowerCase();
      const item      = label.closest('.dropdown-item');
      return {label: labelText, item: item};
    }).get();

    searchBox.val(''); // Clear the search box when the page loads 

    searchBox.on('keyup', () => {
      const searchTerm = searchBox.val().toLowerCase();
      labelToCheckbox.forEach((el) => {
        const inputBox = el.item.find('input.form-check-input');
        if (el.label.includes(searchTerm)) {
          el.item.removeClass('d-none filtered');
          inputBox.removeClass('filtered');
        } else {
          el.item.addClass('d-none filtered');
          inputBox.addClass('filtered');
        }
      });

      const visibleCheckboxes = labelToCheckbox.
        filter(el => !el.item.hasClass('filtered'));
      const checkedBoxes = visibleCheckboxes.
        map(el => el.item.find('input.form-check-input:checked')).
        filter(input => input.length !== 0);
      const visibleCheckboxCount = visibleCheckboxes.length - 1; // Remove the select all box
      const allSelected = visibleCheckboxCount === checkedBoxes.length;
      $(el).find('.select-all-checkbox').prop('checked', allSelected);
    });
  });

  // General Dropdown Functionality
  $('.dropdown').each((idx, el) => {
    const selectAllCheckbox = $(el).find('.select-all-checkbox');
    const allInputs         = $(el).find('input.form-check-input').not('.select-all-checkbox');
    const visibleInputs     = allInputs.not('.filtered');
    const selectedCount     = visibleInputs.filter(':checked').length;
    const allSelected       = visibleInputs.length === selectedCount;
    const isRequired        = $(el).hasClass('required-dropdown');
    const showCount         = $(el).hasClass('show-count-dropdown');
    const form              = $(el).closest('form');

    // Select All
    selectAllCheckbox.prop('checked', allSelected);
    selectAllCheckbox.change((cb) => {
      const isChecked = $(cb)[0].target.checked;

      allInputs.not('.filtered').prop('checked', isChecked).change();
      if (showCount) {
        const totalSelectedCount = $(el).
          find('input.form-check-input').
          not('.select-all-checkbox').
          filter(':checked').
          length;
        setDropdownText($(el), isRequired, totalSelectedCount);
        enableSubmit(form);
      }
    });

    allInputs.change(() => {
      // Disable Submit Handlers
      if (isRequired) {
        enableSubmit(form);
      }

      const visibleInputs       = allInputs.not('.filtered');
      const visibleCheckedCount = visibleInputs.filter(':checked').length;
      const allVisibleSelected  = visibleCheckedCount === visibleInputs.length;

      // Toggle the select all box depending on whether all options are selected
      selectAllCheckbox.prop('checked', allVisibleSelected);

      // Show selected count handler
      if (showCount) {
        setDropdownText($(el), isRequired, allInputs.filter(':checked').length);
      }
    })
    
    // Show selected count
    if (showCount) {
      setDropdownText($(el), isRequired, selectedCount);
    }
  });

  // Initial disable submit
  $('form').each((idx, el) => {
    enableSubmit($(el));
  });
});
